<template>
  <span class="showing-total-text">
    {{ mainText }}
  </span>
</template>

<script>

  /**
   * @author Saiat Kalbiev <kalbievich11@gmail.com>
   */
  export default {
    props: {
      pagination: Object
    },
    computed: {
      mainText() {
        let from = (this.pagination.page - 1) * this.pagination.limit + 1;

        let to = this.pagination.page * this.pagination.limit;
        to = to > this.pagination.total ? this.pagination.total : to;

        return this.$i18n.t('Showing {from} to {to} of {total} entries', {
          from: from === 0 ? 1 : from,
          to: to,
          total: this.pagination.total
        })
      }
    }
  }
</script>

<style lang="scss">
</style>
